import { render, staticRenderFns } from "./DeleteViewModal.vue?vue&type=template&id=12f355fb&scoped=true"
import script from "./DeleteViewModal.vue?vue&type=script&lang=js"
export * from "./DeleteViewModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteViewModal.vue?vue&type=style&index=0&id=12f355fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f355fb",
  null
  
)

export default component.exports